// libraries
import React, { useState, useEffect } from "react";

import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import SwiperCore, { Navigation } from "swiper";

// styles
import styles from "./styles.module.scss";

// mockup
import mockup from "src/utils/data";

// components
import Item from "./Item";

SwiperCore.use([Navigation]);

const MoreEvents = ({ data }) => {
  const [eventList, setEventList] = useState(mockup.empty_3);

  useEffect(() => {
    if (data) setEventList(data.NearMeEvents);
  }, [data]);

  return (
    <div className={styles.more_events}>
      <h3>More Interesting Events</h3>
      <div className={`interesting-events ${styles.list}`}>
        <Swiper
          spaceBetween={12}
          slidesPerView="auto"
          slidesPerGroup={1}
          navigation={true}
          centeredSlides={true}
          cssMode
          freeMode={{
            enabled: true,
            sticky: true,
          }}
          breakpoints={{
            640: {
              centeredSlides: false,
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            768: {
              centeredSlides: false,
              slidesPerView: 3,
              slidesPerGroup: 3,
            },
            900: {
              centeredSlides: false,
              slidesPerView: 4,
              slidesPerGroup: 4,
            },
            1280: {
              centeredSlides: false,
              slidesPerView: 5,
              slidesPerGroup: 5,
            },
          }}
        >
          {eventList.map((item, index) => (
            <SwiperSlide key={index}>
              <Item data={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default MoreEvents;
